const legacyDateFilterRegex = /\|(date|date-time)$/;
import type {Context} from '../types';

/**
 * This Patch removes date/date-time segment of the filter attached to a dyn-bound node.
 */

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const innerHtml = data.dyn && data.dyn.bind && data.dyn.bind.innerHTML;

  const _iterateInnerHTMLBindings = (_jsonNode: Record<any, any>, fn: any) => {
    const innerHTMLBindings = innerHtml;
    if (innerHTMLBindings) {
      innerHTMLBindings.forEach(function (binding: any) {
        const filter = binding.filter;
        if (
          binding.type === 'Date' &&
          filter &&
          legacyDateFilterRegex.test(filter)
        ) {
          fn(binding, filter.replace(legacyDateFilterRegex, ''));
        }
      });
    }
  };

  let patchNeeded = false;

  _iterateInnerHTMLBindings(jsonNode, () => {
    patchNeeded = true;
  });

  return {
    needed: patchNeeded,
    logData: {
      msg: 'Date binding with date/date-time filter segment.',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      _iterateInnerHTMLBindings(
        jsonNode,
        (binding: any, optionFilter: string) => {
          binding.filter = optionFilter;
        }
      );
    },
  };
};
